import { Metadata } from 'next'

const TITLE = 'The Best Way to Ship Luggage | Ship&Play'
const DESCRIPTION =
  'Ship luggage, family essentials, and sports equipment to and from your destination ' +
  'with Ship&Play, to make getting there feel like a vacation, too.'

const metadata: Metadata = {
  title: TITLE,
  alternates: {
    canonical: 'https://www.shipplay.com',
  },
  description: DESCRIPTION,
  openGraph: {
    type: 'website',
    url: 'https://www.shipplay.com/',
    siteName: 'Ship&Play',
    title: TITLE,
    description: DESCRIPTION,
    images: [
      {
        url: 'https://media.shipplay.com/ship-sticks-og-image.png',
        width: 1200,
        height: 630,
        alt: 'Ship&Play luggage and travel gear shipping service',
      },
    ],
  },
}

export default metadata
